import { escapeHtml } from './dom.js';

function parseInline(text) {
  return escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

function parseTable(lines) {
  if (lines.length < 2) return '';
  const rows = lines.filter((l) => l.trim().startsWith('|'));
  if (rows.length < 2) return '';

  const parseRow = (row) =>
    row
      .split('|')
      .slice(1, -1)
      .map((c) => c.trim());

  const header = parseRow(rows[0]);
  const bodyRows = rows.slice(2).map(parseRow);

  return `
    <div class="md-table-wrap">
      <table class="md-table">
        <thead><tr>${header.map((h) => `<th>${parseInline(h)}</th>`).join('')}</tr></thead>
        <tbody>
          ${bodyRows.map((r) => `<tr>${r.map((c) => `<td>${parseInline(c)}</td>`).join('')}</tr>`).join('')}
        </tbody>
      </table>
    </div>
  `;
}

export function renderMarkdown(source) {
  if (!source) return '';

  const lines = String(source).split('\n');
  const parts = [];
  let i = 0;
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) return;
    parts.push(`<ul class="md-list">${listItems.map((li) => `<li>${parseInline(li)}</li>`).join('')}</ul>`);
    listItems = [];
  };

  while (i < lines.length) {
    const line = lines[i];

    if (line.trim().startsWith('|')) {
      flushList();
      const tableLines = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        tableLines.push(lines[i]);
        i += 1;
      }
      parts.push(parseTable(tableLines));
      continue;
    }

    if (/^[-*]\s+/.test(line.trim())) {
      listItems.push(line.trim().replace(/^[-*]\s+/, ''));
      i += 1;
      continue;
    }

    flushList();

    if (!line.trim()) {
      i += 1;
      continue;
    }

    parts.push(`<p class="md-p">${parseInline(line)}</p>`);
    i += 1;
  }

  flushList();
  return `<div class="md-content">${parts.join('')}</div>`;
}
